import { render, staticRenderFns } from "./Deposito.vue?vue&type=template&id=806d50ac&scoped=true"
import script from "./Deposito.vue?vue&type=script&setup=true&lang=js"
export * from "./Deposito.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Deposito.vue?vue&type=style&index=0&id=806d50ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806d50ac",
  null
  
)

export default component.exports